import CircularProgress from '@mui/material/CircularProgress';
import React, { useCallback, useEffect, useRef, useState } from 'react';
// Styles
import { useDispatch, useSelector } from 'react-redux';
import {
	addPlayerToTeam,
	delRoundBPA,
	fanaticModeBefore,
	selectDraftConfig,
	setCountRender,
	setDraftPlayersAction,
	setSelectCardDepth,
	setTeamUniqPositionFanaticChallenge,
	setTradeValue,
	uniqPosition,
} from '../../app/features/draftConfig/draftConfigSlice';
import { delPlayersDraft } from '../../app/features/playersDraft/playersDraftSlice';
import { POSITIONS_COLOR } from '../../utils/constants';
import { isPositionUnique } from '../../utils/utils';
import { draftAutoSettings, draftDisableSettings } from './DraftSettings';
import { PlayerName, PlayerPos, Wrapper } from './DraftViewAsign.styles';

const Delayed = ({ children, waitBefore = 500, scroll = null }) => {
	const [isShow, setIsShow] = useState(false);
	const { countRender } = useSelector(selectDraftConfig);
	useEffect(() => {
		const timer = setTimeout(() => {
			setIsShow(true);
			scroll.teamRef?.current?.scrollTo(0, (countRender - 1) * scroll.teamRef?.current?.lastChild.clientHeight);  //check undefined
		}, waitBefore);
		return () => clearTimeout(timer);
		}, [waitBefore]);

	function Animation() {
		return <CircularProgress style={{ position: 'absolute', right: '10%' }} />;
	}

	return isShow ? children : Animation();
};

const DraftViewAsign = ({ players, thisId }) => {
	const dispatch = useDispatch();


	const {
		teams,
		pauseId,
		timeSpeed,
		tradeValue,
		loading,
		teamPickIndex,
		countRender,
		draftCardDepth,
		draftRandomnessTeam,
		roundBPA,
		roundDepth,
		round,
		selectCardDepth,
		roundStart,
		fanaticIndexPosition,
		fanaticPickId,
		fanaticPlayerBefore,
		fanaticChallenge,
		advancedSetting,
		teamUniqPosition,
		tradingSimulatorAction,
		fanaticMode,
		teamUniqPositionFanaticChallenge,
		teamSelectIndex,
		teamDraftPlayerChoose,
		fanaticModeValue
	} = useSelector(selectDraftConfig);
	const divRef = useRef(null);
	const roundArr = useRef([]);

	const [groupedDuplicates, setGroupedDuplicates] = useState({
		round1: [],
		round2: [],
		round3: [],
		round4: [],
	});

	const groupDuplicates = (teams) => {
		const roundGroups = {
			round1: {},
			round2: {},
			round3: {},
			round4: {},
		};

		teams.forEach((team) => {
			const { tm, round_index_number, iteration } = team;
			const key = `${tm}-${round_index_number}-${iteration}`;
			if (round_index_number === '1') {
				if (!roundGroups.round1[key]) {
					roundGroups.round1[key] = [];
				}
				roundGroups.round1[key].push(team);
			} else if (round_index_number === '2') {
				if (!roundGroups.round2[key]) {
					roundGroups.round2[key] = [];
				}
				roundGroups.round2[key].push(team);
			} else if (round_index_number === '3') {
				if (!roundGroups.round3[key]) {
					roundGroups.round3[key] = [];
				}
				roundGroups.round3[key].push(team);
			} else if (round_index_number === '4') {
				if (!roundGroups.round4[key]) {
					roundGroups.round4[key] = [];
				}
				roundGroups.round4[key].push(team);
			}
		});

		const round1Duplicates = Object.values(roundGroups.round1).filter(group => group.length > 1);
		const round2Duplicates = Object.values(roundGroups.round2).filter(group => group.length > 1);
		const round3Duplicates = Object.values(roundGroups.round3).filter(group => group.length > 1);
		const round4Duplicates = Object.values(roundGroups.round4).filter(group => group.length > 1);

		setGroupedDuplicates({
			round1: round1Duplicates,
			round2: round2Duplicates,
			round3: round3Duplicates,
			round4: round4Duplicates,
		});
	};


	useEffect(() => {
		if (tradeValue?.results) {
			groupDuplicates(tradeValue.results);
		}
	}, [tradeValue?.results]);

	useEffect(() => {
		console.log('Grouped Round 1 Duplicates:', groupedDuplicates.round1);
		console.log('Grouped Round 2 Duplicates:', groupedDuplicates.round2);
		console.log('Grouped Round 3 Duplicates:', groupedDuplicates.round3);
		console.log('Grouped Round 4 Duplicates:', groupedDuplicates.round4);
	}, [groupedDuplicates]);

	const teamRef = useRef(null);
	const handleSetUniquePosition = (round, name, position, iteration) => {
		if (isPositionUnique(teamUniqPositionFanaticChallenge, round, iteration, position, name)) {
			dispatch(setTeamUniqPositionFanaticChallenge({ round, name, position, iteration }));
		} else {
			console.log('Position already chosen in previous rounds/iterations.');
		}
	};

	const advancingSettings = useCallback(() => {
		if (
			tradeValue?.mouthing &&
			!players.loading &&
			players.status &&
			countRender < tradeValue?.results?.length &&
			(countRender + 1 < teamPickIndex[0] || !teamPickIndex?.length) &&
			(countRender + 1 < fanaticIndexPosition[0] || !fanaticIndexPosition?.length)
		) {
			if (!pauseId?.length) {
				let newTradeValue = {};
				let tradeValueTeam = structuredClone(tradeValue.results[countRender]);
				let fanaticFlag = false;
				let teamDepth = [];
				const playersAll = players.results;
				let player = {};
				let roundIndexBool = false;
				let roundIndex = +tradeValueTeam.round_index_number;
				const playerIteration = +tradeValueTeam.iteration;
				if (countRender > 0 && roundBPA?.length !== 0) {
					let teamSlice = tradeValue.results.slice(0, countRender + 1);
					teamSlice.forEach(team => {
						if (team.city === tradeValueTeam.city) {
							teamDepth = team;
						}
					});
				}
				if (roundBPA?.length && !roundBPA.includes(+tradeValueTeam.round_index_number)) {
					roundIndexBool = true;
					dispatch(delRoundBPA(tradeValueTeam.round_index_number));
				}
				if (fanaticPickId?.includes(tradeValueTeam['index']) && fanaticChallenge[0]?.mode && !fanaticMode) {
					// debugger;
					if (fanaticChallenge[0]?.mode === 1) {
						const teamPickOnePlayer = teamDraftPlayerChoose[0].choosePlayers[[tradeValueTeam['iteration'] - 1]];
						if (
							teamPickOnePlayer.id !== fanaticPlayerBefore.filter(item => item.pick === tradeValueTeam['index'])[0].player.id
						) {
							player = fanaticPlayerBefore.filter(item => item.pick === tradeValueTeam['index'])[0]; //check
						}
						else {
							player = draftAutoSettings({
								draftCardDepth,
								draftRandomnessTeam,
								roundBPA,
								roundDepth,
								round,
								playersAll,
								teamDepth,
								tradeValueTeam,
								selectCardDepth,
								roundIndexBool,
								roundIndex,
								teamUniqPosition,
								fanaticChallenge,
								teamPickIndex,
								teamUniqPositionFanaticChallenge,
							});
						}
					} else if (fanaticChallenge[0]?.mode === 2) {
						if (
							tradeValueTeam['iteration'] !== 1 &&
							fanaticChallenge[0]?.mode === 2 &&
							+tradeValueTeam['round_index_number'] === 1 &&
							tradeValueTeam['index'] >= 24 &&
							tradeValueTeam['index'] <= 32
						) {
							player = fanaticPlayerBefore.filter(item => item.pick === tradeValueTeam['index'])[0];
						} else if (
							tradeValueTeam['iteration'] !== 1 &&
							fanaticChallenge[0]?.mode === 2 &&
							+tradeValueTeam['round_index_number'] === 2 &&
							tradeValueTeam['index'] >= 33 &&
							tradeValueTeam['index'] <= 63
						) {
							player = fanaticPlayerBefore.filter(item => item.pick === tradeValueTeam['index'])[0];
						} else {
							player = draftAutoSettings({
								draftCardDepth,
								draftRandomnessTeam,
								roundBPA,
								roundDepth,
								round,
								playersAll,
								teamDepth,
								tradeValueTeam,
								selectCardDepth,
								roundIndexBool,
								roundIndex,
								teamUniqPosition,
								fanaticChallenge,
								teamPickIndex,
								teamUniqPositionFanaticChallenge,
							});
						}
					}
				}
				else {
					player = draftAutoSettings({
						draftCardDepth,
						draftRandomnessTeam,
						roundBPA,
						roundDepth,
						round,
						playersAll,
						teamDepth,
						tradeValueTeam,
						selectCardDepth,
						roundIndexBool,
						roundIndex,
						teamUniqPosition,
						fanaticChallenge,
						teamPickIndex,
						teamUniqPositionFanaticChallenge,
					});
				}
				if (fanaticMode) {
					player = fanaticPlayerBefore.find(player => player?.pick === tradeValueTeam?.index);
					if (!player) {
						player = draftAutoSettings({
							draftCardDepth,
							draftRandomnessTeam,
							roundBPA,
							roundDepth,
							round,
							playersAll,
							teamDepth,
							tradeValueTeam,
							selectCardDepth,
							roundIndexBool,
							roundIndex,
							teamUniqPosition,
							teamPickIndex,
							teamUniqPositionFanaticChallenge,
						});
					}
				}
				const team = tradeValue.results[countRender];
				const { player: playerItem, playerDepth } = player;
				dispatch(
					uniqPosition({
						name: tradeValueTeam.round.name,
						position: player.player.position,
					})
				);
				if (fanaticChallenge.length !== 0) {
					// Recorded for every round — the "same player at most twice" cap covers round 2 too.
					dispatch(
						addPlayerToTeam({
							teamId: team.round.id,
							playerData: { name: playerItem.player, id: playerItem.id },
							infoDraft: { round: roundIndex,
								iteration: team.iteration,
								pick: team.pick },
						})
					);
					// The old wipe of choosePlayers / infoDraft at the end of iterations 5 and 10 is gone —
					// the 2-per-5-iterations reset is handled by the block count in filterPlayers, and
					// wiping the record here would also clear the user team's no-repeat history.
				}
				handleSetUniquePosition(
					+tradeValueTeam.round_index_number,
					tradeValueTeam.round.name,
					player.player.position,
					tradeValueTeam.iteration
				);
				tradeValueTeam['player'] = playerItem;
				tradeValueTeam['playerDepth'] = playerDepth;
				if(fanaticMode){
					tradeValueTeam['iteration'] = playerIteration;
				}
				let newTradeValueResults = tradeValue.results.map(team => {
					if (team['index_position']) {
						return team['index_position'] === tradeValueTeam['index_position'] ? tradeValueTeam : team;
					} else {
						return team.index === tradeValueTeam.index ? tradeValueTeam : team;
					}
				});
				newTradeValue = {
					...tradeValue,
					results: newTradeValueResults,
				};
				if (!fanaticMode) {
					!selectCardDepth.includes(playerDepth) && dispatch(setSelectCardDepth(playerDepth));
				}
				dispatch(setTradeValue(newTradeValue));
				dispatch(setDraftPlayersAction(tradeValueTeam));
				dispatch(delPlayersDraft([playerItem], tradeValueTeam?.iteration));
				dispatch(setCountRender());
				if (fanaticFlag) {
					dispatch(fanaticModeBefore({ player, action: 'dec' }));
				}
			}
		}
		}, [tradeValue.mouthing, players.loading, pauseId, players.status]);

	const advancingSettingsDefault = useCallback(() => {
		if (
			tradeValue?.mouthing &&
			!players.loading &&
			players.status &&
			countRender < tradeValue.results.length &&
			(countRender + 1 < teamPickIndex[0] || !teamPickIndex.length) &&
			!pauseId.length
		) {
			let newTradeValue = {};
			let tradeValueTeam = structuredClone(tradeValue.results[countRender]);
			const playersAll = players.results;
			let roundIndex = +tradeValueTeam.round_index_number;
			let { player } = draftDisableSettings({
				teamUniqPosition,
				playersAll,
				tradeValueTeam,
				roundIndex,
				round,
			});
			tradeValueTeam['player'] = player;
			let newTradeValueResults = tradeValue.results.map(team => {
				return team.index === tradeValueTeam.index ? tradeValueTeam : team;
			});
			newTradeValue = {
				...tradeValue,
				results: newTradeValueResults,
			};
			dispatch(
				uniqPosition({
					name: tradeValueTeam.round.name,
					position: player.position,
				})
			);
			handleSetUniquePosition(
				+tradeValueTeam.round_index_number,
				tradeValueTeam.round.name,
				player.player.position,
				tradeValueTeam.iteration
			);
			dispatch(setTradeValue(newTradeValue));
			dispatch(setDraftPlayersAction(tradeValueTeam));
			dispatch(delPlayersDraft([player], tradeValueTeam?.iteration));
			dispatch(setCountRender());
		}
	}, [tradeValue.mouthing, players.loading, pauseId, players.status]);

	useEffect(() => {
		if (!advancedSetting && !tradingSimulatorAction) {
			advancingSettings();
			return;
		}
		advancingSettingsDefault();
	}, [tradeValue.mouthing, players.loading, pauseId, players.status]);

	function delayTime({ id, indexPosition }) {
		const isTeamPick = currentValue => currentValue > id;
		const isIndexPosition = currentValue => currentValue > indexPosition;
		if (fanaticIndexPosition?.length) {
			return fanaticIndexPosition.every(isIndexPosition) ? indexPosition * (1000 / timeSpeed / indexPosition) : 0;
		} else if (!fanaticIndexPosition?.length) {
			return teamPickIndex.every(isTeamPick) ? id * (1000 / timeSpeed / id) : 0;
		} else {
			return;
		}
	}

	return (
		<Wrapper ref={divRef}>
			{players?.length > 0 && loading ? <CircularProgress /> : null}
			<ul ref={teamRef}>
				{tradeValue?.results?.map((team, idx) => {
					const {
						index: id,
						round_index: roundIndex,
						index_position: indexPosition,
						round: { logo, name },
						iteration,
						team_neads_info,
					} = team;
					let position = team_neads_info.team_neads_info.map(item => item.positions).flat();
					const checkTeam = delayTime({ id, indexPosition });
					const time = thisId ? +(id - thisId) * (1000 / timeSpeed) : checkTeam;
					const teamActive = fanaticIndexPosition?.length
						? fanaticIndexPosition?.includes(indexPosition)
						: teamPickIndex.includes(id);
					if (roundStart.includes(id)) {
						roundArr.current = [];
					}
					const roundCheck = roundArr.current.includes(roundIndex) ? false : roundArr.current.push(roundIndex);

					return (
						<React.Fragment key={idx}>
							{roundCheck ? (
								<li className="round" key={Math.random()}>
									{roundIndex} {iteration && `Iteration ${iteration}`}
								</li>
							) : null}
							<li key={id} className={`${teamActive ? 'player-team active' : 'player-team'}`}>
								<div className="heto-poxel">
									{team?.index_position ? (
										<div className="pick">
											<p>Pick</p>
											<p>{id}</p>
										</div>
									) : (
										<div className="pick">
											<p>Pick</p>
											<p>{id}</p>
										</div>
									)}
									<div className="player-team-info">
										<img src={logo ? logo : ''} alt={name} />
										{!!checkTeam && team?.player ? null : (
											<>
												{teamActive ? (
													<div className="player-click">On The Clock</div>
												) : (
													<div className="player-dashed">- - -</div>
												)}
											</>
										)}
										{!!checkTeam && (
											<Delayed
												waitBefore={time}
												scroll={{
													teamRef,
													id,
													thisId,
													player: team.player ? true : false,
												}}
											>
												{team?.player ? (
													<>
														<PlayerName>{team?.player?.player}</PlayerName>
														<PlayerPos backColor={POSITIONS_COLOR[team?.player?.position]}>
															{team.player.position}
														</PlayerPos>
														<p className="player-college">{team?.player?.school}</p>
													</>
												) : (
													<CircularProgress style={{ position: 'absolute', right: '10%' }} />
												)}
											</Delayed>
										)}
									</div>
								</div>
								<div className="needs">
									{position.map((need, idx) => (
										<p key={idx}>{need.name}</p>
									))}
								</div>
							</li>
						</React.Fragment>
					);
				})}
			</ul>
		</Wrapper>
	);
};

export default DraftViewAsign;
